/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DatabaseEntryUpdateCreate
 */
export interface DatabaseEntryUpdateCreate {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof DatabaseEntryUpdateCreate
     */
    fieldsValues?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof DatabaseEntryUpdateCreate
     */
    belongsTo?: string;
}

/**
 * Check if a given object implements the DatabaseEntryUpdateCreate interface.
 */
export function instanceOfDatabaseEntryUpdateCreate(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseEntryUpdateCreateFromJSON(json: any): DatabaseEntryUpdateCreate {
    return DatabaseEntryUpdateCreateFromJSONTyped(json, false);
}

export function DatabaseEntryUpdateCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseEntryUpdateCreate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fieldsValues': !exists(json, 'fieldsValues') ? undefined : json['fieldsValues'],
        'belongsTo': !exists(json, 'belongsTo') ? undefined : json['belongsTo'],
    };
}

export function DatabaseEntryUpdateCreateToJSON(value?: DatabaseEntryUpdateCreate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fieldsValues': value.fieldsValues,
        'belongsTo': value.belongsTo,
    };
}

